module.exports = __webpack_public_path__ + "img/002.bcd8f05a.jpg";